import { JSX } from "react";

export function SBDContainer({ children }: { readonly children: React.ReactNode }): JSX.Element {
  return (
    <div className="flex h-full w-full flex-col overflow-hidden [animation-play-state:paused]">
      {children}
    </div>
  );
}
